import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateSellerStatus } from '@/data/api/request/sellerRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useToggleSellerStatus() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  return useMutation({
    mutationFn: async (args: { sellerId: string; currentlyActive: boolean }) =>
      updateSellerStatus({
        sellerId: args.sellerId,
        updateSellerStatusRequest: {
          business_status: args.currentlyActive ? 'INACTIVE' : 'ACTIVE',
        },
      }),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.seller.list] });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.seller.details, vars.sellerId],
      });
      showSnackSuccess(
        vars.currentlyActive ? 'Vendedor desactivado' : 'Vendedor activado'
      );
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });
}
